<template>
    <input
        v-bind="$attrs"
        v-model="modelValue"
        type="radio"
        :dusk="dusk"
        :value="value"
        :class="[
            'border-gray-300 shadow-sm text-brand-600 focus:border-brand-300 focus:ring focus:ring-brand-200/50',
            sizeClass,
        ]"
        :required="required"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { FieldComponent } from '@src/Common/Components/types';

const props = defineProps<FieldComponent>();

const emit = defineEmits(['update:modelValue']);

const modelValue = computed({
    get: () => props.modelValue,
    set: (val: string | number) => emit('update:modelValue', val),
});

const sizeClass = computed(() => {
    const sizes = {
        xs: 'w-2 h-2',
        sm: 'w-3 h-3',
        base: 'w-4 h-4',
        lg: 'w-5 h-5',
        xl: 'w-6 h-6',
    };
    return sizes[props.size ?? 'base'];
});
</script>
